import MetaTags from "./index";
import { defaultMetatags } from "@/lib/constants";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags(episode) {
  const keywords =
    episode?.meta_keywords && episode?.meta_keywords?.length > 0
      ? episode.meta_keywords.join(",")
      : null;
  const genre = episode?.genres?.[0]?.name || "";

  return {
    title: `${episode.name}【${genre}】の動画配信 | スカパー！動画ストア`,
    keywords: keywords || defaultMetatags.vod.keywords,
    description: `${episode.name}の再生画面。スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！`,
    og: {
      type: "video.episode",
      url: `${config.host.vod}${routes.watch(episode.id)}`,
    },
    twitter: {
      card: "summary",
    },
  };
}

export default function WatchMetaTags({ episode }) {
  const props = tags(episode);
  return <MetaTags {...props} />;
}
